import { addClientSideAsset, upsertClientAssets, deleteClientSideAssets } from '../privateActions';
import { createTimeStreamAsset } from '../actions';
import { orchestrator } from 'satcheljs';
import createAssetOnServer from './createAssetOnServer';
import generateAssetId from '../assetId/generateAssetId';
import localAssetIdMap from '../assetId/localAssetIdMap';
import updateAssetMap from '../assetId/updateAssetMap';

orchestrator(createTimeStreamAsset, ({ projectId, asset, source }) => {
    const clientAssetId = generateAssetId();

    // Issue the request
    const createAssetPromise = createAssetOnServer(projectId, asset, source);

    // When server call completes, update the server->client id map, update the lie with full info and return server id.
    // This in turns will update the client->server id map and release any patches waiting for the server id.
    const assetIdPromise = createAssetPromise
        .then(outlookSpaceAsset => {
            localAssetIdMap.set(outlookSpaceAsset.id, clientAssetId);
            upsertClientAssets(projectId, [outlookSpaceAsset]);
            return outlookSpaceAsset.id;
        })
        .catch(e => {
            deleteClientSideAssets(projectId, [clientAssetId]);
            throw e;
        });

    updateAssetMap(clientAssetId, assetIdPromise);

    // Add the asset to the store so the canvas can select and draw it immediately.
    addClientSideAsset(projectId, clientAssetId, asset, source);
});
